import { useEffect, useRef } from 'react';

export const useLessonWindow = (lessonWindow: Window, onClose: () => void) => {
  const timerId = useRef(-1);

  function handleMessage(event?: MessageEvent) {
    if (!event || event.data === 'lessonComplete') {
      window.clearInterval(timerId.current);
      onClose();
    }
  }

  useEffect(() => {
    if (lessonWindow) {
      timerId.current = window.setInterval(() => {
        if (!lessonWindow.window) {
          handleMessage();
        }
      }, 1000);
    }
    return () => clearInterval(timerId.current);
  }, [lessonWindow]);

  return { handleMessage };
};
